/**
 * Labstep
 *
 * @module screens/File/Index
 * @desc File index
 */

import FileActionCreate from 'labstep-web/components/File/Action/Create';
import { FileEmptyState } from 'labstep-web/components/File/EmptyState';
import { FileListOrTable } from 'labstep-web/components/File/ListOrTable';
import GuardGroupCreate from 'labstep-web/components/Guard/GroupCreate';
import { File } from 'labstep-web/models/file.model';
import { FileIndexLeftPane } from 'labstep-web/screens/File/Index/LeftPane';
import { MasterIndex } from 'labstep-web/screens/Master/Index';
import type React from 'react';
import { useMemo } from 'react';
import { filters } from './constants';
import type { IFileIndexProps } from './types';

export const FileIndex: React.FC<IFileIndexProps> = ({ group }) => {
  const params = useMemo(
    () => ({
      group_id: group.id,
      parent_type_not: 'profile', // We don't want to show profile pictures
    }),
    [group.id],
  );
  const action = useMemo(
    () => (
      <GuardGroupCreate>
        <FileActionCreate multiple />
      </GuardGroupCreate>
    ),
    [],
  );
  const leftPane = useMemo(() => <FileIndexLeftPane />, []);
  const noResultsMessage = useMemo(() => <FileEmptyState />, []);
  return (
    <MasterIndex
      entityName={File.entityName}
      leftPane={leftPane}
      params={params}
      noResultsMessage={noResultsMessage}
      action={action}
      filters={filters}
    >
      {({
        entities,
        ...rest
      }: {
        entities: File[];
      }): React.ReactElement => (
        <FileListOrTable files={entities} {...rest} />
      )}
    </MasterIndex>
  );
};
